export default function DSA_Arrays() {
  return <div>DSA_Arrays Component</div>;
}
